import React from "react";
import "./Birthdays.css";
import ThisMonth from "./ThisMonth";
import NextMonth from "./NextMonth";
import ThisMonthBd from "./ThisMonthBd";
import NextMonthBd from "./NextMonthBd";
import "./Wishes.css";

const WishesByMonths = () => {
  return (
    <div className="wishes">
      <div className="element">
        <h2 className="title">
          Birthdays On <span className="sm-display-date">This Month</span>
          <ThisMonth />
        </h2>
        <div className="today">
          <ThisMonthBd />
        </div>
      </div>
      <div className="element">
        <h2 className="title">
          Birthdays On <span className="sm-display-date">Next Month</span>
          <NextMonth />
        </h2>
        <div className="tomorrow">
          <NextMonthBd />
        </div>
      </div>
    </div>
  );
};

export default WishesByMonths;
